import PropTypes from 'prop-types';
import StepsDots from 'components/UI/StepsDots';
import { ROUTE_PATH } from 'routes';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as ImgClose } from 'assets/icons/close.svg';
import { useState } from 'react';
import Button from 'components/UI/Button';
import Modal from 'components/Modal';
import useLiterals from 'utils/hooks/useLiterals';
import { GA_REGISTRATION_ACTIONS } from 'constants/gaEvents';

const StepHeader = ({ step, onEvent }) => {
  const literals = useLiterals('registration');
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    onEvent(GA_REGISTRATION_ACTIONS.EXIT);
    navigate(ROUTE_PATH.HOME);
  };

  return (
    <>
      <div className='flex justify-between items-center mb-6'>
        <StepsDots current={step} total={8} />
        <ImgClose height={16} onClick={() => setShowModal(true)} />
      </div>
      {showModal && (
        <Modal position='end' onClose={() => setShowModal(false)} showCloseButton={false}>
          <p className='font-semibold text-primary mt-4 mb-6 text-lg'>{literals.confirmExit}</p>
          <Button className='mb-2' onClick={handleClose}>{literals.common.confirm}</Button>
          <Button type='outline-primary' onClick={() => setShowModal(false)}>{literals.common.cancel}</Button>
        </Modal>
      )}
    </>
  );
};

StepHeader.propTypes = {
  step: PropTypes.number.isRequired,
  onEvent: PropTypes.func.isRequired,
};

export default StepHeader;
